import { render, staticRenderFns } from "./MyPaymentComponent.vue?vue&type=template&id=7886de64&"
import script from "./MyPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./MyPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports